import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.closing],
    info: construction.info.closing,
    loaded: construction.parameters_loaded,
    selected: construction.selected.closing
  })
);
